import type { RateInfo } from '../../types/electricity'
import { useLanguage } from '../../i18n/LanguageContext'

export function RateLabel({ rate }: { rate: RateInfo }) {
  const { t } = useLanguage()
  const colorClass = rate.tier === 'peak' ? 'text-gradient-red' : 'text-gradient-green'
  const label = rate.tier === 'peak' ? t('rate.expensive') as string : t('rate.cheap') as string
  const seasonName = t(`seasons.${rate.season}` as 'seasons.winter') as string

  return (
    <div className="text-center space-y-1">
      <p className={`font-heading text-2xl font-bold ${colorClass}`}>
        {label}
      </p>
      <p className="text-slate-400 text-sm">
        {t('rate.season') as string} {seasonName}
      </p>
    </div>
  )
}
